var $class="se2--content-article-slide-carousel--slide",$name="ContentArticleSlideCarousel/slide",$path="app/components/ContentArticleSlideCarousel/partials/slide/index.js",$this={$class,$name,$path,};const contentArticleSlideCarouselSlideSelector = `.${$class}`;

export default contentArticleSlideCarouselSlideSelector;
